import { RowActionIndicator } from '@/components/atoms/RowActionIndicator/RowActionIndicator';
import { focusVisibleRing } from '@/components/ui/constants';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

export const CARD_CLASSES =
  'flex items-center self-stretch rounded-lg border border-border bg-background';

export const RoleCardSkeleton = () => (
  <div className={cn(CARD_CLASSES, 'p-4')}>
    <div className="min-w-0 flex-1 space-y-2">
      <Skeleton className="h-5 w-32" />
      <Skeleton className="h-5 w-64" />
    </div>
  </div>
);

type Props = { name: string; description?: string; onViewPermissions: () => void };

export const RoleCard = ({ name, description, onViewPermissions }: Props) => (
  <button
    type="button"
    onClick={onViewPermissions}
    className={cn(
      CARD_CLASSES,
      'group gap-2 p-4 text-left hover:bg-selected-soft',
      focusVisibleRing
    )}
  >
    <div className="min-w-0 flex-1">
      <p className="text-sm leading-5 font-semibold text-foreground">{name}</p>
      {description && (
        <p className="mt-1 truncate text-sm leading-5 text-muted-foreground">{description}</p>
      )}
    </div>
    <RowActionIndicator action="view" />
  </button>
);
